import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditVasDetailsViewModel } from 'src/app/models/audit-vas-details-view-model';
import { AuditService } from 'src/app/services/audit.service';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';

@Component({
  selector: 'app-audit-vas-details',
  templateUrl: './audit-vas-details.component.html',
  styleUrls: ['./audit-vas-details.component.scss']
})
export class AuditVasDetailsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public vasDetails: AuditVasDetailsViewModel[] = [];

  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.vasDetails = await this._auditService.GetVASDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.vasDetails, 'MerchantAuditTrail_VAS_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
